import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { uniqueId } from 'lodash'
import React, { FC, useState } from 'react'
import { secToHour, secToMinute } from '../../../utils/date'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'
import Tips from '../common/Tips'

export interface LabelGroup {
  id: number
  name: string
  color: string
  time: {
    scheduled: number | null // 予定時間
    actual: number // 実際にかかった時間
  }
  cost: {
    scheduled: number | null // 予算
    actual: number // 実際にかかったコスト
    other: number // その他コスト
  }
  approved: boolean
}

export interface LabelGroupCategory {
  id: number
  name: string
  color: string
  time: {
    scheduled: number | null // 予定時間
    actual: number // 実際にかかった時間
  }
  cost: {
    scheduled: number | null // 予算
    actual: number // 実際にかかったコスト
    other: number // その他コスト
  }
  approved: boolean
  label_group_duplicated: boolean
  children: {
    label_group_categories: LabelGroupCategory[]
    label_groups: LabelGroup[]
  }
}

interface List {
  label_group_categories: LabelGroupCategory[]
  label_groups: LabelGroup[]
}

interface LabelGroups {
  id: number
  name: string
  code: string | null
  color: string
}

interface Props {
  list: List
  costView: boolean
  displayApprovalIcon?: boolean
}

const DetailRowForCategory: FC<Props> = (props) => {
  const {
    list,
    costView,
    displayApprovalIcon,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const [openLabelGroupCategoryIds, setOpenLabelGroupCategoryIds] = useState<(number | null)[]>([])

  const isExistLabelGroupCategoryId = (id: number | null) => openLabelGroupCategoryIds.includes(id)

  const toggleLabelGroupCategoryId = (id: number | null) => {
    if (isExistLabelGroupCategoryId(id)) {
      setOpenLabelGroupCategoryIds(openLabelGroupCategoryIds.filter((v) => v !== id))
    } else {
      setOpenLabelGroupCategoryIds([...openLabelGroupCategoryIds, id])
    }
  }

  const buildCategoryList = (children: {label_group_categories: LabelGroupCategory[], label_groups: LabelGroup[]}, level = 0): JSX.Element => {
    if (!children.label_group_categories.length && !children.label_groups.length) return (<></>)
    return (
      <>
        {
          children.label_groups.map((v, i) => (
            <React.Fragment key={`list_category_name_${v.name}`}>
              <div
                className="list_row_wrapper for_category"
                style={{
                  marginBottom: !!level && !children.label_group_categories.length && children.label_groups.length === i + 1 ? "8px" : "0",
                }}
              >
                {
                  !!level && (
                    <div
                      className="ruler_area"
                      style={{
                        width: `${level * 20}px`,
                      }}
                    >
                      {
                        !i && (
                          <>
                            <div className="vertical" />
                            <div className="horizontal" />
                          </>
                        )
                      }
                    </div>
                  )
                }
                <div
                  className={`list_row${costView ? " cost_view" : ""}`}
                  style={{ cursor: "default" }}
                >
                  <div className="title_display_area">
                    <div className="text_area">
                      <div
                        className="icon"
                        style={{
                          backgroundColor: v.color,
                          borderRadius: "0",
                        }}
                      />
                      {v.name}
                      {
                        login.function_enabled_state?.task_management_approval
                        && !!v.time
                        && displayApprovalIcon
                        && (
                          <>
                            <Tips
                              description={v.approved ? "すべてのデータが承認済みです" : "一部未承認のデータがあります"}
                              className=""
                              icon={false}
                              style={{
                                padding: 0,
                                width: "auto",
                              }}
                              key={uniqueId()}
                            >
                              <>
                                <div className={`approved_label${v.approved ? "" : " not_approved"}`}>
                                  {v.approved ? "済" : "未"}
                                </div>
                              </>
                            </Tips>
                          </>
                        )
                      }
                    </div>
                  </div>
                  <div className="work_time">
                    <div>
                      {
                        Number(secToHour(v.time.actual)) > 0
                          ? (
                            <>
                              <span>
                                {secToHour(v.time.actual)}
                              </span>
                              時間
                            </>
                          )
                          : ""
                      }
                      {
                        Number(secToMinute(v.time.actual)) > 0
                          ? (
                            <>
                              <span>
                                {secToMinute(v.time.actual)}
                              </span>
                              分
                            </>
                          )
                          : ""
                      }
                      {
                        (v.time.actual) < 60 && (v.time.actual) > 0
                          ? "1分未満"
                          : ""
                      }
                      {
                        (v.time.actual) === 0
                          ? "0分"
                          : ""
                      }
                    </div>
                  </div>
                  {
                    costView && (
                      <div className="work_cost">
                        <div>
                          {`¥${Math.floor(v.cost.actual).toLocaleString()}`}
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            </React.Fragment>
          ))
        }
        {
          children.label_group_categories.map((v, i) => (
            <React.Fragment key={`${v.name}`}>
              <div
                className="list_row_wrapper for_category"
                style={{
                  marginBottom:
                    isExistLabelGroupCategoryId(v.id)
                    || (!!level && children.label_group_categories.length === i + 1)
                      ? '8px'
                      : '0',
                }}
              >
                {
                  !!level && (
                    <div
                      className="ruler_area"
                      style={{
                        width: `${level * 20}px`,
                      }}
                    >
                      {
                        !i && !children.label_groups.length && (
                          <>
                            <div className="vertical" />
                            <div className="horizontal" />
                          </>
                        )
                      }
                    </div>
                  )
                }
                <div
                  className={`list_row${costView ? " cost_view" : ""}`}
                  onClick={() => (!!v.children.label_group_categories.length || !!v.children.label_groups.length) && toggleLabelGroupCategoryId(v.id)}
                  style={{ cursor: (!!v.children.label_group_categories.length || !!v.children.label_groups.length) ? "pointer" : "default" }}
                  role="none"
                >
                  <div className="title_display_area">
                    <div className="text_area">
                      <FontAwesomeIcon
                        icon={['fas', isExistLabelGroupCategoryId(v.id) ? 'folder-open' : 'folder']}
                        style={{
                          color: v.color,
                        }}
                      />
                      {v.name}
                      {
                        login.function_enabled_state?.task_management_approval
                        && !!v.time
                        && displayApprovalIcon
                        && (
                          <>
                            <Tips
                              description={v.approved ? "すべてのデータが承認済みです" : "一部未承認のデータがあります"}
                              className=""
                              icon={false}
                              style={{
                                padding: 0,
                                width: "auto",
                              }}
                              key={uniqueId()}
                            >
                              <>
                                <div className={`approved_label${v.approved ? "" : " not_approved"}`}>
                                  {v.approved ? "済" : "未"}
                                </div>
                              </>
                            </Tips>
                          </>
                        )
                      }
                    </div>
                    {
                      (!!v.children.label_group_categories.length || !!v.children.label_groups.length) && (
                        <button
                          type="button"
                        >
                          {isExistLabelGroupCategoryId(v.id) ? "閉じる" : "開く"}
                          <FontAwesomeIcon icon={['fas', isExistLabelGroupCategoryId(v.id) ? 'angle-up' : 'angle-down']} />
                        </button>
                      )
                    }
                  </div>
                  <div
                    className="work_time"
                    style={{
                      color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#4372ba",
                    }}
                  >
                    {
                      v.label_group_duplicated && (
                        <Tips
                          description="カテゴリー内に同一プロジェクトが重複設定されていますが、集計値は重複データを除外しています"
                          className="fit"
                          icon={false}
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          <>
                            <FontAwesomeIcon icon={['fas', 'info-circle']} />
                          </>
                        </Tips>
                      )
                    }
                    <div>
                      {
                        Number(secToHour(v.time.actual)) > 0
                          ? (
                            <>
                              <span>
                                {secToHour(v.time.actual)}
                              </span>
                              時間
                            </>
                          )
                          : ""
                      }
                      {
                        Number(secToMinute(v.time.actual)) > 0
                          ? (
                            <>
                              <span>
                                {secToMinute(v.time.actual)}
                              </span>
                              分
                            </>
                          )
                          : ""
                      }
                      {
                        (v.time.actual) < 60 && (v.time.actual) > 0
                          ? "1分未満"
                          : ""
                      }
                      {
                        (v.time.actual) === 0
                          ? "0分"
                          : ""
                      }
                    </div>
                  </div>
                  {
                    costView && (
                      <div
                        className="work_cost"
                        style={{
                          color: isExistLabelGroupCategoryId(v.id) ? "#CCCCCC" : "#4372ba",
                        }}
                      >
                        {
                          v.label_group_duplicated && (
                            <Tips
                              description="カテゴリー内に同一プロジェクトが重複設定されていますが、集計値は重複データを除外しています"
                              className="fit"
                              icon={false}
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              <>
                                <FontAwesomeIcon icon={['fas', 'info-circle']} />
                              </>
                            </Tips>
                          )
                        }
                        <div>
                          {`¥${Math.floor(v.cost.actual).toLocaleString()}`}
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
              {isExistLabelGroupCategoryId(v.id) && buildCategoryList(v.children, level + 1)}
            </React.Fragment>
          ))
        }
      </>
    )
  }

  return buildCategoryList(list)
}

DetailRowForCategory.defaultProps = {
  displayApprovalIcon: false,
}

export default DetailRowForCategory
